import React from 'react';
import {Link, useUrl} from '@shopify/hydrogen';
// import LogoIcon from '../icons/Logo';
import clsx from 'clsx';
// @ts-expect-error @headlessui/react incompatibility with node16 resolution
import {Popover} from '@headlessui/react';

//components
import Container from './ContainerClient.client';
import CartToggle from '../cart/CartToggle.client';
import {UserIcon} from '../icons/User';
import CountrySelect from './CountrySelect.client';
import LanguageSelect from './LanguageSelect.client';
import MenuMobile from './MenuMobile.client';
import Search from './Search.client';
import CurrencySelect from './CurrencySelect.client';
import type {Brand} from '../../types';
import SanityImage from './SanityImage.client';
import sanityConfig from '../../../sanity.config';

//assets
// import Logo from '../../../public/helmet-king-logo.png';

interface Props {
  menu: any;
  allBrands: Brand[] | undefined;
  logoRef: any;
  business:any
}

export default function HeaderMain({menu, allBrands, logoRef, business}: Props) {
  // const [scrolledDown, setScrolledDown] = useState(false);

  // const handleScroll = () => {
  //   setScrolledDown(window.scrollY > 100);
  // };

  // useEffect(() => {
  //   window.addEventListener('scroll', handleScroll);
  //   // Trigger handler on mount to account for reloads
  //   handleScroll();
  //   return () => window.removeEventListener('scroll', handleScroll);
  // }, []);

  return (
    <div className="absolute top-0 left-0 z-10 w-full md:py-5">
      <div
        className={clsx([
          'absolute inset-0 bg-white opacity-100 duration-500',
          // 'absolute inset-0 bg-white bg-opacity-90 opacity-100 backdrop-blur-lg backdrop-filter duration-500',
          // scrolledDown ? 'opacity-100' : 'opacity-0',
        ])}
      />
      <Container className="relative flex h-full w-full items-center justify-between lg:px-5">
        <div className="z-10 flex items-center">
          {/* Hamburger Menu */}
          <Popover className="mr-2 md:hidden">
            {({open}) => (
              <>
                <Popover.Button className="outline-none">
                  {open ? (
                    <div className="flex w-[40px] items-center justify-center">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M7.5 9.35849L1.85849 15L0 13.1415L5.64151 7.5L0 1.85849L1.85849 0L7.5 5.64151L13.1415 0L15 1.85849L9.35849 7.5L15 13.1415L13.1415 15L7.5 9.35849Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                  ) : (
                    <svg
                      clipRule="evenodd"
                      fillRule="evenodd"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-[40px]"
                    >
                      <path
                        d="m21 4c0-.478-.379-1-1-1h-16c-.62 0-1 .519-1 1v16c0 .621.52 1 1 1h16c.478 0 1-.379 1-1zm-4 11.25c0 .414-.336.75-.75.75h-8.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h8.5c.414 0 .75.336.75.75zm0-3.248c0 .414-.336.75-.75.75h-8.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h8.5c.414 0 .75.336.75.75zm0-3.252c0 .414-.336.75-.75.75h-8.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h8.5c.414 0 .75.336.75.75z"
                        fillRule="nonzero"
                      />
                    </svg>
                  )}
                </Popover.Button>

                <Popover.Panel className="fixed left-0 top-0 z-[100] h-[calc(100vh-148px)] w-full translate-y-[148px]">
                  <div className="absolute left-0 top-0 h-full w-full bg-black bg-opacity-20"></div>
                  <div className="z-1 absolute top-0 left-0 h-full w-10/12 bg-white shadow-md">
                    {allBrands && (
                      <MenuMobile menu={menu} allBrands={allBrands} business={business}/>
                    )}
                  </div>
                </Popover.Panel>
              </>
            )}
          </Popover>
          <Link to="/">
            <div className="w-[150px] md:w-[184px]">
              <SanityImage
                dataset={sanityConfig.dataset}
                layout="responsive"
                projectId={sanityConfig.projectId}
                sizes={['50vw, 100vw']}
                src={logoRef?.asset._ref}
              />
            </div>
          </Link>
        </div>
        {/* Desktop Search */}
        <div className="z-10 hidden flex-shrink-0 items-center md:flex lg:w-[35%] xl:w-1/2">
          <Search />
        </div>
        <div className="flex items-center">
          {/* Language Select */}
          <div
            className={clsx(
              'hidden', //
              'lg:block',
            )}
          >
            <LanguageSelect />
          </div>
          {/* Country select */}
          <div
            className={clsx(
              'hidden', //
              'lg:block',
            )}
          >
            <CountrySelect />
          </div>
          {/* Country select */}
          <div
            className={clsx(
              'hidden', //
              'lg:block',
            )}
          >
            <CurrencySelect />
          </div>
          {/* Account */}
          <Link
            className={clsx([
              'dh-[2.4rem] items-center rounded-sm bg-darkGray bg-opacity-0 p-1',
              'lg:flex',
              'hover:bg-opacity-10',
            ])}
            to="/account"
          >
            <UserIcon />
          </Link>
          {/* Cart */}
          <div className="flex h-full items-center justify-center py-4">
            <CartToggle />
          </div>
        </div>
      </Container>
      <div className="md:hidden">
        <Search />
      </div>
    </div>
  );
}
